<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <table class="mt-2" style="width:100%;">
          <!-- Modérateur -->
          <tr>
            <td>{{ $t("invitation.tracking.profile") }}</td>
            <td class="font-weight-bold">
              <span v-if="solicitation.name" :title="solicitation.public_id">{{ solicitation.name }}</span>
              <span v-else>Admin</span>
            </td>
          </tr>
          <tr class="sr-table-line">
            <td colspan="2">
              <hr>
            </td>
          </tr>

          <!-- Information sur le client -->
          <tr>
            <td>{{ $t("invitation.tracking.name") }}</td>
            <td v-if="solicitation.first_name || solicitation.last_name" class="font-weight-bold">
              {{ solicitation.first_name }} {{ solicitation.last_name }}
            </td>
            <td v-else class="font-weight-bold"> -</td>
          </tr>
          <tr>
            <td>{{ $t("invitation.tracking.email") }}</td>
            <td class="font-weight-bold">{{ solicitation.email }}</td>
          </tr>
          <tr class="sr-table-line">
            <td colspan="2">
              <hr>
            </td>
          </tr>
          <!-- Informations sur la demande de sollicitation -->
          <tr>
            <td>{{ $t("invitation.tracking.link") }}</td>
            <td class="font-weight-bold">
              <span v-if="((solicitation.about_ext_review_url==='NO')||(!solicitation.about_ext_review_url))">
                <a :title="solicitation.link"><b style="color:orange;">{{ solicitation.link }}...</b></a>
              </span>
              <span v-if="solicitation.about_ext_review_url==='ONLY'">
                <a :title="solicitation.link" :href="solicitation.ext_review_url"><b style="color:orange;">{{ solicitation.ext_review_url }}</b></a>
              </span>
              <span v-if="solicitation.about_ext_review_url==='BOTH'">
                <a :title="solicitation.link"><b style="color:orange;">{{ solicitation.link }}...</b></a><br>
                <a :title="solicitation.link" :href="solicitation.ext_review_url"><b style="color:orange;">{{ solicitation.ext_review_url }}</b></a>
              </span>

            </td>
          </tr>
          <tr>
            <td>{{ $t("invitation.tracking.created_at") }}</td>
            <td class="font-weight-bold"> {{ solicitation.created_at }}</td>
          </tr>
          <tr v-if="solicitation.is_canceled">
            <td>{{ $t("invitation.tracking.canceled_at") }}</td>
            <td class="font-weight-bold" style="color:red;"> {{ solicitation.canceled_at }}</td>
          </tr>
          <tr>
            <td>{{ $t("invitation.tracking.mail_delay") }}</td>
            <td class="font-weight-bold">
              {{ $tc("invitation.tracking.mail_delay_format", solicitation.mail_delay) }}
            </td>
          </tr>

          <tr v-if="solicitation.mail_resend_nb>0">
            <td>{{ $t("invitation.tracking.mail_next_resend_at") }}</td>
            <td class="font-weight-bold">
              {{ solicitation.mail_next_resend_at }}
            </td>
          </tr>
          <tr v-if="solicitation.mail_resent_nb>0">
            <td>{{ $t("invitation.tracking.mail_resent_nb") }}</td>
            <td class="font-weight-bold">
              {{ solicitation.mail_resent_nb }}
            </td>
          </tr>
          <tr v-else>
            <td>{{ $t("invitation.tracking.mail_resent_nb") }}</td>
            <td class="font-weight-bold">
              {{ $t("invitation.tracking.no_more_resend") }}
            </td>
          </tr>
          <tr v-if="solicitation.mail_resent_nb>0&&solicitation.is_mail_clicked===0">
            <td>{{ $t("invitation.tracking.mail_next_resend_at") }}</td>
            <td class="font-weight-bold">
                            <span v-if="solicitation.is_canceled" style="text-decoration: line-through;">
                              {{ solicitation.mail_next_resend_at }}
                            </span>
              <span v-else>
                              {{ solicitation.mail_next_resend_at }}
                            </span>

            </td>
          </tr>

          <tr v-if="solicitation.mail_1_resend_at!==null">
            <td>{{ $t("invitation.tracking.mail_1_resend_at") }}</td>
            <td class="font-weight-bold">
              {{ solicitation.mail_1_resend_at }}
            </td>
          </tr>
          <tr v-if="solicitation.mail_2_resend_at!==null">
            <td>{{ $t("invitation.tracking.mail_2_resend_at") }}</td>
            <td class="font-weight-bold">
              {{ solicitation.mail_2_resend_at }}
            </td>
          </tr>
          <tr v-if="solicitation.mail_3_resend_at!==null">
            <td>{{ $t("invitation.tracking.mail_3_resend_at") }}</td>
            <td class="font-weight-bold">
              {{ solicitation.mail_3_resend_at }}
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <hr>
            </td>
          </tr>
          <tr>
            <td>{{ $t("invitation.tracking.product") }}</td>
            <td class="font-weight-bold"> {{ solicitation.product ? solicitation.product : "-" }}</td>
          </tr>
          <tr>
            <td>{{ $t("invitation.tracking.thematics") }}</td>
            <td class="font-weight-bold">
              {{ solicitation.thematics ? solicitation.thematics : "-" }}
            </td>
          </tr>
          <!-- Informations revalidation -->
          <tr class="sr-table-line">
            <td colspan="2">
              <hr>
            </td>
          </tr>
          <tr>
            <td valign="top">{{ $t("invitation.tracking.revalidate.title") }}</td>
            <td>
              <span class="font-weight-bold">{{ solicitation.need_revalidate ? $t("invitation.tracking.revalidate.need_revalidate_true") : $t("invitation.tracking.revalidate.need_revalidate_false") }}</span>
              <div v-if="solicitation.need_revalidate">
                <span class="font-weight-bold">{{ solicitation.is_revalidated ? $t("invitation.tracking.revalidate.is_revalidated_true") : $t("invitation.tracking.revalidate.is_revalidated_false") }}</span><br>
                <span>{{ $t("invitation.tracking.revalidate.revalidated_at") }} : <span class="font-weight-bold">{{ solicitation.revalidated_at ? solicitation.revalidated_at : "-" }}</span></span><br>
                <span>{{ $t("invitation.tracking.revalidate.revalidate_type") }} :
                  <span class="font-weight-bold" v-if="solicitation.revalidate_type==='P'">{{ $t("invitation.tracking.revalidate.revalidate_type_P") }}</span>
                  <span class="font-weight-bold" v-else-if="solicitation.revalidate_type==='D'">{{ $t("invitation.tracking.revalidate.revalidate_type_D") }}</span>
                  <span class="font-weight-bold" v-else-if="solicitation.revalidate_type==='T'">{{ $t("invitation.tracking.revalidate.revalidate_type_T") }}</span>
                  <span class="font-weight-bold" v-else>{{ $t("invitation.tracking.revalidate.revalidate_type_A") }}</span>
                </span>
              </div>
            </td>
          </tr>
          <!-- Informations Meta datas -->
          <tr class="sr-table-line">
            <td colspan="2">
              <hr>
            </td>
          </tr>
          <tr>
            <td valign="top">{{ $t("invitation.tracking.meta_data") }}</td>
            <td>
              <div class="font-weight-bold" v-html="printInvitationMeta($t('invitation.tracking.meta_data_metas'),solicitation.meta_data,'metas')"></div>
              <div class="font-weight-bold" v-html="printInvitationMeta($t('invitation.tracking.meta_data_customer'),solicitation.meta_data,'customer')"></div>
              <div class="font-weight-bold" v-html="printInvitationMeta($t('invitation.tracking.meta_data_order'),solicitation.meta_data,'order')"></div>
              <div class="font-weight-bold" v-html="printInvitationMeta($t('invitation.tracking.meta_data_gift'),solicitation.meta_data,'gift')"></div>
              <div class="font-weight-bold" v-html="printInvitationMeta($t('invitation.tracking.meta_data_custom'),solicitation.meta_data,'custom')"></div>
            </td>
          </tr>
        </table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "SolicitationView",
  props: {
    solicitation: { required: true },
  },
  methods: {
    printInvitationMeta(title,metaJsonStr, part) {
      let html = ''
      let html_content = ''

      let metaObj = JSON.parse(metaJsonStr)
      if(metaObj) {
        if (metaObj[part]) {
          for (var k in metaObj[part]) {
            if(metaObj[part][k] !== "") {
              let view_k = k.replace('meta_','')
              html_content += '<tr class="font-weight-light"><td>'+view_k.toUpperCase() + '</td><td>' + metaObj[part][k] + '</td></tr>'
            }
          }
          html = html.trim()
        }
      }
      if(html_content) {
        html += '<b>'+title+'</b><br>'
        html += '<table style="width:100%;border:1px;margin-left:10px;margin-bottom:10px;margin-top:5px;" >'
        html += '<tr><td style="width:40%;"><u>'+this.$t('form.keys')+'</u></td><td style="width:60%;"><u>'+this.$t('form.values')+'</u></td></tr>'
        html += html_content
        html += '</table>'
      }
      return html;
    },
  }
}
</script>
